import { useQuery } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import type { ListRequest, Paged } from "@/core/api/pagination";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { feeEngineEndpoints } from "@/features/fee-engine/api/endpoints";
import type {
  SubscriptionPlanDto,
  SubscriptionPlanFilter,
} from "@/features/fee-engine/api/dto";

/** Liste paginée des plans d'abonnement (`POST /SubscriptionPlans/all`). */
export const useSubscriptionPlans = (
  params: ListRequest<SubscriptionPlanFilter> = {},
  enabled = true
) =>
  useQuery({
    queryKey: QUERY_KEYS.FEE_SUBSCRIPTION_PLANS_LIST(params),
    queryFn: () =>
      mutateData({
        url: feeEngineEndpoints.subscriptionPlans.all,
        reqBody: params as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<Paged<SubscriptionPlanDto>>,
    enabled,
  });
